export class PromptVersionDTO {
  id?: number;
  promptId?: number;
  versionNumber?: number;
  previousPromptText?: string;

  constructor(data?: Partial<PromptVersionDTO>) {
    if (data) {
      this.bindData(data);
    }
  }

  bindData(data: Partial<PromptVersionDTO>) {
    if (data.id !== undefined) this.id = data.id;
    if (data.promptId !== undefined) this.promptId = data.promptId;
    if (data.versionNumber !== undefined) this.versionNumber = data.versionNumber;
    if (data.previousPromptText !== undefined) this.previousPromptText = data.previousPromptText;
  }
} 